import type { TFunction } from 'i18next';

const whatsappTemplateVariableKeys = [
  'clientName',
  'clientFirstName',
  'clientLastName',
  'agentName',
  'agentFirstName',
  'agentLastName',
] as const;

export type WhatsappTemplateVariableKey =
  (typeof whatsappTemplateVariableKeys)[number];

export const getWhatsappTemplateVariables = (t: TFunction) =>
  whatsappTemplateVariableKeys.map((key) => ({
    key,
    token: t(`whatsapp.settings.quickReplies.help.placeholders.${key}.token`),
    description: t(
      `whatsapp.settings.quickReplies.help.placeholders.${key}.description`,
    ),
  }));
